import { render, staticRenderFns } from "./copy-edition-modal.vue?vue&type=template&id=7e403057&"
import script from "./copy-edition-modal.vue?vue&type=script&lang=ts&"
export * from "./copy-edition-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports